import styled, { css } from 'styled-components';
export const Span = styled.span `
  ${({ $semibold, color, theme }) => {
    return css `
      color: ${color || 'inherit'};
      font-weight: ${$semibold ? theme.fontWeights.semibold : 'inherit'};
    `;
}}
`;
